import type { ApiDataTransformer } from '@kiplin/web-common/architecture-core';
import { injectable } from 'inversify';
import type { ClientSeasonApiData } from '@client/entity/client-season/data/api-data/client-season.api-data';
import type { ClientSeasonFillingRate } from '@client/entity/client-season/domain/model/client-season-filling-rate.model';

@injectable()
export class ClientSeasonApiDataTransformer implements ApiDataTransformer<
  ClientSeasonApiData,
  ClientSeasonFillingRate | null
> {
  public map(data: ClientSeasonApiData): ClientSeasonFillingRate | null {
    if (!data.fillingRate) {
      return null;
    }

    return {
      current: data.fillingRate.currentAttendeeCount,
      total: data.fillingRate.maxSubscriptions,
      percentage: data.fillingRate.percentage,
    };
  }
}
